<template>
  <div class="bg-black py-5 lg:block lg:h-10 lg:py-0">
    <div class="pl:pl-0 mx-auto h-full max-w-7xl md:pl-4">
      <div class="h-full lg:flex lg:items-center lg:justify-between">
        <div
          class="flex h-full flex-col divide-y divide-shade-600 text-lg lg:flex-row lg:items-center lg:divide-y-0 lg:divide-x"
        >
          <ul
            v-for="(category, i) in menu"
            :key="i"
            class="flex flex-col space-y-4 py-4 px-6 leading-none lg:inline lg:space-x-6 lg:py-0 lg:px-3 lg:first:pl-0 lg:last:pr-0"
            :class="category.customClass"
          >
            <li
              v-for="item in category.items"
              :key="item.label"
              class="lg:inline"
              :class="item.customClass"
            >
              <NuxtLink
                class="text-mobile-lg capitalize lg:text-base lg:normal-case"
                :to="item.href"
                :class="category.color"
              >
                {{ $t(item.label) }}
              </NuxtLink>
            </li>
          </ul>
        </div>
        <div class="hidden text-right lg:flex">
          <MiscLangSwitcher />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from '#i18n'
import NavigationChevronDown from '~/assets/icon/navigation/Chevron/Down.svg'

const { t } = useI18n()

// Menu
const menu = ref<RootMenu>([
  {
    color: 'text-label-yellow',
    items: [
      {
        label: 'menu.ircam',
        href: 'https://www.ircam.fr/',
      },
      {
        label: 'menu.career',
        href: 'https://www.ircam.fr/',
      },
    ],
  },
  {
    color: 'text-white',
    items: [
      {
        label: 'menu.calls_for_application',
        href: 'https://www.ircam.fr/',
      },
      {
        label: 'menu.newsletter',
        href: 'https://www.ircam.fr/',
      },
      {
        label: 'menu.arrive',
        href: 'https://www.ircam.fr/',
      },
      {
        label: 'menu.boutique',
        href: 'https://www.ircam.fr/',
      },
    ],
  },
  {
    color: 'text-primary-300',
    items: [
      {
        label: 'labels.resource_center',
        href: '/',
      },
    ],
    customClass: 'hidden lg:inline',
  },
])
</script>
